var map = {
	"./balcony.svg": "aac7",
	"./ceiling.svg": "97a4",
	"./chimney.svg": "e2a4",
	"./exterior-tiles.svg": "1c2e",
	"./facade.svg": "1050",
	"./floor.svg": "0655",
	"./gutters.svg": "3869",
	"./installations.svg": "b47e",
	"./insulation.svg": "b63c",
	"./interior-tiles.svg": "0204",
	"./plinth.svg": "6a7d",
	"./roof.svg": "139a",
	"./soft-joints.svg": "b1e6",
	"./sole-benches.svg": "6a77",
	"./stairs.svg": "f72c",
	"./walls.svg": "9223",
	"./window.svg": "5da3",
	"./woodwork.svg": "8c35"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d5b4";